module.exports = __webpack_public_path__ + "static/media/nature-lab.284ab644.png";